import _ from 'lodash';
import { onDownload } from '@/infrastructure/utils/onDownload';
import DeepViewIcon from 'library-@/components/deep-view/index.vue';
import '@patsnap-ui/icon/assets/solid/warning.svg';
import '@patsnap-ui/icon/assets/solid/FilePdf.svg';
import '@patsnap-ui/icon/assets/solid/s.svg';
import '@patsnap-ui/icon/assets/solid/litigation.svg';
import '@patsnap-ui/icon/assets/solid/licence.svg';
import { Icon as PzIcon } from 'patsnap-biz';
import { injectService } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
import { useLab } from '@/presentation/composables/use-lab';
import { E_LABS_NAME } from '@/domains/lab/enums';
import { useUserPermission } from '@/presentation/composables/user/use-user-permission';
export const name = 'PN.render';
// 默认显示模板
function renderDefault(h, renderOpts, params) {
    const i18n = injectService(i18nSymbol);
    const { enableLabDeepView, getAnchorItem } = useLab();
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const { PN, PATENT_ID, TITLE_LANG = '', HAS_LITIGATION, HAS_LICENSE, HAS_STANDARD, } = row || {};
    const toggleDeepView = () => {
        this.$eventHub.$emit('SpaceDetail:ExcelGrid:ToggleDeepViewIcon', row);
    };
    const vnodes = [];
    vnodes.push(PN
        ? (<a class="pn-cell-popover" target="_blank" data-patent-id={PATENT_ID} data-link-type="PN" data-link-data={PN} data-patent-no={PN}>
                    {PN}
                </a>)
        : (<div class="empty-pn">
                    <PzIcon icon="SolidWarning" style="font-size: 20px;"/>
                    <span class="hover-display-line">{i18n.t('deleteEmptyData.emptyData')}</span>
                </div>));
    if (PN) {
        vnodes.push(<div class="ws-deep-view">
                <DeepViewIcon patent-data={row} data-balloon-pos="left" onToggleDeepViewIcon={toggleDeepView} usedByAnchorDeepView={getAnchorItem(E_LABS_NAME.DEEP_VIEW)} deepViewLabOn={enableLabDeepView.value}/>,
            </div>);
        if (HAS_LITIGATION) { // TODO: 需要验证一下颜色
            vnodes.push(<a class="legal-icon side-icon" title={i18n.t('workspace.settings.legal.litigation')} target="_blank" data-link-type="litigation" data-link-data={PN} data-patent-id={PATENT_ID} data-patent-no={PN}>
                <PzIcon icon="SolidLitigation" style="font-size: 20px;"/>
            </a>);
        }
        if (HAS_LICENSE) {
            vnodes.push(<a class="legal-icon side-icon" title={i18n.t('workspace.settings.legal.licensing')} target="_blank" data-link-type="licensing" data-link-data={PN} data-patent-id={PATENT_ID} data-patent-no={PN}>
                <PzIcon icon="SolidLicence" style="font-size: 20px;"/>
            </a>);
        }
        if (HAS_STANDARD) {
            vnodes.push(<a class="legal-icon side-icon" title={i18n.t('workspace.settings.legal.standard')} target="_blank" data-link-type="PN" data-link-data={PN} data-patent-id={PATENT_ID} data-patent-no={PN}>
                <PzIcon icon="SolidS" style="font-size: 20px;"/>
            </a>);
        }
        const { userPermission } = useUserPermission();
        userPermission.value.enable_pdf_download && vnodes.push(<span class="pn-cell-download-pdf" aria-label={i18n.t('app.patentActions.download')} data-balloon-pos="left" onClick={() => {
                onDownload({ PATENT_ID, TITLE_LANG }, this);
            }}>
            <PzIcon icon="SolidFilePdf" style={{ fontSize: '20px' }}/>
        </span>);
    }
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name}>
            {vnodes}
        </div>,
    ];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    return row[column.property];
}
export default {
    renderDefault,
    exportMethod,
};
